import LoaderPage from 'components/ui/feedback/LoaderPage'
import useAdminSettings from 'hooks/useAdminSettings'
import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const CollectionsListPage = lazy(() => import('pages/collections/page'))
const CollectionsV2Page = lazy(() => import('pages/collectionsv2/page'))

const CollectionsRoutes: React.FunctionComponent<RouteProps> = () => {
  const { enableCollectionsV2 } = useAdminSettings()

  return (
    <Routes>
      <Route
        path="/"
        element={<LoaderPage content={enableCollectionsV2 ? <CollectionsV2Page /> : <CollectionsListPage />} />}
      />
    </Routes>
  )
}

export default CollectionsRoutes
